import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import RecordsContainer from "./RecordsContainer";
import {
	fetchGoogleAnalyticsData,
	fetchSummaryData,
} from "../../../redux/dashboard/index";
import moment from "moment";
import AnalyticsChart from "./AnalyticsChart";
import TimePicker from "../../components/date/TimePickerComponent";
import TableView from "../../../components/Table/TableView";
import { Icon, Typography } from "@material-ui/core";
import SummaryCardComponent from "../../components/dashboard/SummaryCardComponent";
import { getAcceptedColor } from "../../../helpers/helperMethods";

export default () => {
	const summaryData = useSelector((state) => state.summaryDataGlobalStore);

	const analyticsData = useSelector(
		(state) => state.googleAnalyticsGlobalStore
	);

	const dispatch = useDispatch();
	const [state, setState] = useState({
		date: {
			endDate: moment().format("YYYY-MM-DD"),
			startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
		},
	});

	let startDate = moment(
		state.date && state.date.startDate ? state.date.startDate : state.date
	).format("YYYY-MM-DD");
	let endDate = moment(
		state.date && state.date.endDate ? state.date.endDate : state.date
	).format("YYYY-MM-DD");

	if (state.today) {
		startDate = moment().format("YYYY-MM-DD");
		endDate = moment().format("YYYY-MM-DD");
	} else if (state.daily) {
		startDate = moment(state.date).subtract(1, "d").format("YYYY-MM-DD");
		endDate = moment(state.date).subtract(1, "d").format("YYYY-MM-DD");
	} else if (state.weekly) {
		startDate = moment(state.date).subtract(7, "d").format("YYYY-MM-DD");
	} else if (state.monthly) {
		startDate = moment(state.date).subtract(1, "M").format("YYYY-MM-DD");
	} else if (state.yearly) {
		startDate = moment(state.date).subtract(1, "y").format("YYYY-MM-DD");
	}
	useEffect(() => {
		if (
			!summaryData.data[0] ||
			(state.date && state.date.startDate) ||
			state.date !== moment().format("YYYY-MM-DD") ||
			state.daily ||
			state.weekly ||
			state.monthly ||
			state.yearly
		) {
			dispatch(fetchGoogleAnalyticsData(startDate, endDate));
			dispatch(fetchSummaryData(startDate, endDate));
		}
	}, [state]);

	const onRangeChange = (range) => setState({ [range]: !state[range] });
	const onDateChange = (date) => setState({ ...date });

	const headCells = [
		{
			id: "page",
			numeric: false,
			label: "Page path",
		},
		{
			id: "userEngagementDuration",
			numeric: true,
			label: "User Engagement\n(minutes)",
		},
		{
			id: "screenPageViews",
			numeric: true,
			label: "Page Views",
		},
		{
			id: "sessions",
			numeric: true,
			label: "Sessions",
		},
		{
			id: "activeUsers",
			numeric: true,
			label: "Active Users",
		},
		{
			id: "newUsers",
			numeric: true,
			label: "New Users",
		},
		,
	];

	const rows =
		analyticsData.data.data?.pagePath.map((el) => ({
			page: <Typography>{el.name}</Typography>,
			userEngagementDuration: Math.round(el.userEngagementDuration / 60),
			screenPageViews: el.screenPageViews,
			sessions: el.sessions,
			activeUsers: el.activeUsers,
			newUsers: el.newUsers,
		})) || [];

	return (
		<div>
			{analyticsData.loading && !analyticsData.data.country ? (
				<Loading />
			) : (
				<>
					<TimePicker
						startDate={startDate}
						endDate={endDate}
						currentDate={moment().format("YYYY-MM-DD")}
						onRangeChange={onRangeChange}
						onDateChange={onDateChange}
						lastSyncTime={moment().format("LLL") || "00:00 AM"}
					/>
					<Typography variant="h5">Current Standings</Typography>
					<RecordsContainer
						isUpdating={summaryData.loading && summaryData.data}
						recordsToDisplay={summaryData.data || {}}
					/>
					<Typography variant="h5">Website Analytics</Typography>

					{analyticsData.data.data?.summary ? (
						<div
							style={{
								backgroundColor: "#fff",
								padding: "3vh 20px",
								marginBottom: "5vh",
								borderRadius: "6px",
							}}
						>
							<Typography variant="h6" style={{ textAlign: "center" }}>
								Summary
							</Typography>
							<br />
							<div
								style={{
									display: "flex",
									flexWrap: "wrap",
									flexDirection: "row",
									gap: "10px",
									justifyContent: "space-around",
									paddingBottom: "5vh",
								}}
							>
								<SummaryCardComponent
									icon="preview"
									title="Page Views"
									value={analyticsData.data.data.summary.screenPageViews || 0}
									colorObj={getAcceptedColor(7)}
								/>
								<SummaryCardComponent
									icon="schedule"
									title="User Engagement (min)"
									value={
										analyticsData.data.data.summary.userEngagementDuration
											? Math.round(
													analyticsData.data.data.summary
														.userEngagementDuration / 60
											  )
											: 0
									}
									colorObj={getAcceptedColor(4)}
								/>
								<SummaryCardComponent
									icon="computer"
									title="Sessions"
									value={analyticsData.data.data.summary.sessions || 0}
									colorObj={getAcceptedColor(2)}
								/>
								<SummaryCardComponent
									icon="person_add"
									title="New users"
									value={analyticsData.data.data.summary.newUsers || 0}
									colorObj={getAcceptedColor(8)}
								/>
								<SummaryCardComponent
									icon="group"
									title="Active users"
									value={analyticsData.data.data.summary.activeUsers || 0}
									colorObj={getAcceptedColor(6)}
								/>
							</div>
						</div>
					) : (
						""
					)}

					<AnalyticsChart
						chartData={
							analyticsData.data.data?.country
								? {
										...analyticsData.data,
										country: analyticsData.data.data.country.sort(
											(a, b) => b.screenPageViews - a.screenPageViews
										),
										deviceCategory: analyticsData.data.data.deviceCategory.sort(
											(a, b) => b.screenPageViews - a.screenPageViews
										),
										date: analyticsData.data.data.date.sort(
											(a, b) => new Date(a.name) - new Date(b.name)
										),
								  }
								: {}
						}
						isUpdating={analyticsData.loading && analyticsData.data}
						isDateRange={startDate !== endDate}
					/>

					<div>
						<TableView
							dense
							headCells={headCells}
							rows={rows}
							title="Page Visits"
						/>
					</div>
				</>
			)}
		</div>
	);
};
